module.exports = __webpack_public_path__ + "static/media/workbook_interpersonalBoundaries.977d6695.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/papers/boundaries2/workbook_interpersonalBoundaries.pdf
// module id = 145
// module chunks = 0